export default "__VITE_ASSET__dd7c8988__"